export default __webpack_public_path__ + "static/media/paid-leave.c9762ec2.svg";